export { LoyaltyHomeFaq } from './LoyaltyHomeFaq';
